import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    deleteSocioEcoHistoryRequest: ['response'],
    deleteSocioEcoHistorySuccess: ['response'],
    deleteSocioEcoHistoryFailure: ['error'],
})

export const deleteSocioEcoHistoryTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const deleteSocioEcoHistoryRequest = state => state.merge({ success: null })

const deleteSocioEcoHistorySuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const deleteSocioEcoHistoryFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}
export const reducer = createReducer(INITIAL_STATE, {
    [Types.DELETE_SOCIO_ECO_HISTORY_REQUEST]: deleteSocioEcoHistoryRequest,
    [Types.DELETE_SOCIO_ECO_HISTORY_SUCCESS]: deleteSocioEcoHistorySuccess,
    [Types.DELETE_SOCIO_ECO_HISTORY_FAILURE]: deleteSocioEcoHistoryFailure,
})
